import { render, staticRenderFns } from "./SimpleLayout.vue?vue&type=template&id=91b35bba&scoped=true"
import script from "./SimpleLayout.vue?vue&type=script&lang=js"
export * from "./SimpleLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b35bba",
  null
  
)

export default component.exports